// extracted by mini-css-extract-plugin
module.exports = {"item":"BlockItem_item__36UWl","header":"BlockItem_header__3bgm9","content":"BlockItem_content__3crEj"};